import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Mail, Phone, Building2, Baby } from "lucide-react";
import { admin } from "@/lib/api";
import { TabHeader, Badge, fmtDate } from "@/admin/ui";

export default function InquiriesTab() {
  const [items, setItems] = useState(null);

  const load = () => admin.inquiries().then(setItems).catch(() => toast.error("Could not load inquiries"));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-inquiries-tab">
      <div className="flex items-start justify-between gap-4">
        <TabHeader title="Inquiries" description="Every contact form submission, newest first. You also receive each one by email." />
        <button onClick={load} data-testid="admin-inquiries-refresh" className="btn-secondary !px-4 !py-2 !text-xs">
          <RefreshCw className="h-3.5 w-3.5" /> Refresh
        </button>
      </div>
      <div className="mt-8 space-y-4">
        {(items || []).map((i) => (
          <div key={i.id} data-testid={`admin-inquiry-${i.id}`} className="rounded-2xl border border-border bg-card p-6 shadow-soft">
            <div className="flex flex-wrap items-center gap-3">
              <p className="text-sm font-semibold text-foreground">{i.name}</p>
              <Badge tone="forest">{i.service_label || i.service}</Badge>
              <span className="text-xs text-muted-foreground">{fmtDate(i.created_at)}</span>
            </div>
            <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1.5 text-xs text-muted-foreground">
              <span className="flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> {i.email}</span>
              {i.phone && <span className="flex items-center gap-1.5"><Phone className="h-3.5 w-3.5" /> {i.phone}</span>}
              {i.organization && <span className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5" /> {i.organization}</span>}
              {i.child_age && <span className="flex items-center gap-1.5"><Baby className="h-3.5 w-3.5" /> Age {i.child_age}</span>}
              <span>Prefers: {i.preferred_contact}</span>
            </div>
            <p className="mt-4 rounded-xl bg-muted/50 p-4 text-sm leading-relaxed text-foreground/90">{i.message}</p>
          </div>
        ))}
        {items && items.length === 0 && (
          <p className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">No inquiries yet.</p>
        )}
      </div>
    </div>
  );
}
